/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RegisterImport } from './routes/register'
import { Route as PostalRequestCodeImport } from './routes/postal-request-code'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as InactivityLogoutImport } from './routes/inactivity-logout'
import { Route as GeoBlockImport } from './routes/geo-block'
import { Route as AgeRestrictedImport } from './routes/age-restricted'
import { Route as AppRouteImport } from './routes/_app/route'
import { Route as AppVerificationRequiredImport } from './routes/_app/verification-required'
import { Route as AppAccountLockedImport } from './routes/_app/account-locked'
import { Route as AppStoreRouteImport } from './routes/_app/store/route'
import { Route as AppSearchRouteImport } from './routes/_app/search/route'
import { Route as AppRedemptionHistoryRouteImport } from './routes/_app/redemption-history/route'
import { Route as AppRedeemRouteImport } from './routes/_app/redeem/route'
import { Route as AppQuestsRouteImport } from './routes/_app/quests/route'
import { Route as AppPurchaseHistoryRouteImport } from './routes/_app/purchase-history/route'
import { Route as AppActivityLogRouteImport } from './routes/_app/activity-log/route'
import { Route as AppAccountVerificationRouteImport } from './routes/_app/account-verification/route'
import { Route as AppIndexRouteImport } from './routes/_app/index/route'
import { Route as AppStorePlayForFreeImport } from './routes/_app/store/play-for-free'
import { Route as AppStoreBuyGoldCoinsImport } from './routes/_app/store/buy-gold-coins'
import { Route as AppQuestsQuestsHistoryImport } from './routes/_app/quests/quests-history'
import { Route as AppQuestsActiveQuestsImport } from './routes/_app/quests/active-quests'
import { Route as AppAccountVerificationTncImport } from './routes/_app/account-verification_/tnc'
import { Route as AppAccountVerificationFlowImport } from './routes/_app/account-verification_/flow'
import { Route as AppYourPlayGameplayLimitsRouteImport } from './routes/_app/your-play.gameplay-limits/route'
import { Route as AppYourPlayGameplayHistoryRouteImport } from './routes/_app/your-play.gameplay-history/route'
import { Route as AppYourPlayAccessControlsRouteImport } from './routes/_app/your-play.access-controls/route'
import { Route as AppGamePlayGameIdRouteImport } from './routes/_app/game-play.$gameId/route'
import { Route as AppCategoryIdRouteImport } from './routes/_app/category.$id/route'
import { Route as AppYourPlayGameplayLimitsAllRouteImport } from './routes/_app/your-play.gameplay-limits/all/route'
import { Route as AppYourPlayGameplayLimitsAddRouteImport } from './routes/_app/your-play.gameplay-limits/add/route'
import { Route as AppYourPlayAccessControlsTakeABreakConfirmationRouteImport } from './routes/_app/your-play.access-controls/take-a-break-confirmation/route'
import { Route as AppYourPlayAccessControlsTakeABreakRouteImport } from './routes/_app/your-play.access-controls/take-a-break/route'
import { Route as AppYourPlayAccessControlsSelfExclusionConfirmationRouteImport } from './routes/_app/your-play.access-controls/self-exclusion-confirmation/route'
import { Route as AppYourPlayAccessControlsSelfExclusionRouteImport } from './routes/_app/your-play.access-controls/self-exclusion/route'
import { Route as AppYourPlayAccessControlsAllRouteImport } from './routes/_app/your-play.access-controls/all/route'
import { Route as AppYourPlayGameplayLimitsManageTypeRouteImport } from './routes/_app/your-play.gameplay-limits/manage.$type/route'

// Create/Update Routes

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const PostalRequestCodeRoute = PostalRequestCodeImport.update({
  id: '/postal-request-code',
  path: '/postal-request-code',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InactivityLogoutRoute = InactivityLogoutImport.update({
  id: '/inactivity-logout',
  path: '/inactivity-logout',
  getParentRoute: () => rootRoute,
} as any)

const GeoBlockRoute = GeoBlockImport.update({
  id: '/geo-block',
  path: '/geo-block',
  getParentRoute: () => rootRoute,
} as any)

const AgeRestrictedRoute = AgeRestrictedImport.update({
  id: '/age-restricted',
  path: '/age-restricted',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppVerificationRequiredRoute = AppVerificationRequiredImport.update({
  id: '/verification-required',
  path: '/verification-required',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountLockedRoute = AppAccountLockedImport.update({
  id: '/account-locked',
  path: '/account-locked',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppStoreRouteRoute = AppStoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSearchRouteRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppRedemptionHistoryRouteRoute = AppRedemptionHistoryRouteImport.update({
  id: '/redemption-history',
  path: '/redemption-history',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppRedeemRouteRoute = AppRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppQuestsRouteRoute = AppQuestsRouteImport.update({
  id: '/quests',
  path: '/quests',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPurchaseHistoryRouteRoute = AppPurchaseHistoryRouteImport.update({
  id: '/purchase-history',
  path: '/purchase-history',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppActivityLogRouteRoute = AppActivityLogRouteImport.update({
  id: '/activity-log',
  path: '/activity-log',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountVerificationRouteRoute =
  AppAccountVerificationRouteImport.update({
    id: '/account-verification',
    path: '/account-verification',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppIndexRouteRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppStorePlayForFreeRoute = AppStorePlayForFreeImport.update({
  id: '/play-for-free',
  path: '/play-for-free',
  getParentRoute: () => AppStoreRouteRoute,
} as any)

const AppStoreBuyGoldCoinsRoute = AppStoreBuyGoldCoinsImport.update({
  id: '/buy-gold-coins',
  path: '/buy-gold-coins',
  getParentRoute: () => AppStoreRouteRoute,
} as any)

const AppQuestsQuestsHistoryRoute = AppQuestsQuestsHistoryImport.update({
  id: '/quests-history',
  path: '/quests-history',
  getParentRoute: () => AppQuestsRouteRoute,
} as any)

const AppQuestsActiveQuestsRoute = AppQuestsActiveQuestsImport.update({
  id: '/active-quests',
  path: '/active-quests',
  getParentRoute: () => AppQuestsRouteRoute,
} as any)

const AppAccountVerificationTncRoute = AppAccountVerificationTncImport.update({
  id: '/account-verification_/tnc',
  path: '/account-verification/tnc',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAccountVerificationFlowRoute = AppAccountVerificationFlowImport.update(
  {
    id: '/account-verification_/flow',
    path: '/account-verification/flow',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppYourPlayGameplayLimitsRouteRoute =
  AppYourPlayGameplayLimitsRouteImport.update({
    id: '/your-play/gameplay-limits',
    path: '/your-play/gameplay-limits',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppYourPlayGameplayHistoryRouteRoute =
  AppYourPlayGameplayHistoryRouteImport.update({
    id: '/your-play/gameplay-history',
    path: '/your-play/gameplay-history',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppYourPlayAccessControlsRouteRoute =
  AppYourPlayAccessControlsRouteImport.update({
    id: '/your-play/access-controls',
    path: '/your-play/access-controls',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppGamePlayGameIdRouteRoute = AppGamePlayGameIdRouteImport.update({
  id: '/game-play/$gameId',
  path: '/game-play/$gameId',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCategoryIdRouteRoute = AppCategoryIdRouteImport.update({
  id: '/category/$id',
  path: '/category/$id',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppYourPlayGameplayLimitsAllRouteRoute =
  AppYourPlayGameplayLimitsAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

const AppYourPlayGameplayLimitsAddRouteRoute =
  AppYourPlayGameplayLimitsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

const AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute =
  AppYourPlayAccessControlsTakeABreakConfirmationRouteImport.update({
    id: '/take-a-break-confirmation',
    path: '/take-a-break-confirmation',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsTakeABreakRouteRoute =
  AppYourPlayAccessControlsTakeABreakRouteImport.update({
    id: '/take-a-break',
    path: '/take-a-break',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute =
  AppYourPlayAccessControlsSelfExclusionConfirmationRouteImport.update({
    id: '/self-exclusion-confirmation',
    path: '/self-exclusion-confirmation',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsSelfExclusionRouteRoute =
  AppYourPlayAccessControlsSelfExclusionRouteImport.update({
    id: '/self-exclusion',
    path: '/self-exclusion',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayAccessControlsAllRouteRoute =
  AppYourPlayAccessControlsAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AppYourPlayAccessControlsRouteRoute,
  } as any)

const AppYourPlayGameplayLimitsManageTypeRouteRoute =
  AppYourPlayGameplayLimitsManageTypeRouteImport.update({
    id: '/manage/$type',
    path: '/manage/$type',
    getParentRoute: () => AppYourPlayGameplayLimitsRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/age-restricted': {
      id: '/age-restricted'
      path: '/age-restricted'
      fullPath: '/age-restricted'
      preLoaderRoute: typeof AgeRestrictedImport
      parentRoute: typeof rootRoute
    }
    '/geo-block': {
      id: '/geo-block'
      path: '/geo-block'
      fullPath: '/geo-block'
      preLoaderRoute: typeof GeoBlockImport
      parentRoute: typeof rootRoute
    }
    '/inactivity-logout': {
      id: '/inactivity-logout'
      path: '/inactivity-logout'
      fullPath: '/inactivity-logout'
      preLoaderRoute: typeof InactivityLogoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/postal-request-code': {
      id: '/postal-request-code'
      path: '/postal-request-code'
      fullPath: '/postal-request-code'
      preLoaderRoute: typeof PostalRequestCodeImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-verification': {
      id: '/_app/account-verification'
      path: '/account-verification'
      fullPath: '/account-verification'
      preLoaderRoute: typeof AppAccountVerificationRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/activity-log': {
      id: '/_app/activity-log'
      path: '/activity-log'
      fullPath: '/activity-log'
      preLoaderRoute: typeof AppActivityLogRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/purchase-history': {
      id: '/_app/purchase-history'
      path: '/purchase-history'
      fullPath: '/purchase-history'
      preLoaderRoute: typeof AppPurchaseHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/quests': {
      id: '/_app/quests'
      path: '/quests'
      fullPath: '/quests'
      preLoaderRoute: typeof AppQuestsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/redeem': {
      id: '/_app/redeem'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof AppRedeemRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/redemption-history': {
      id: '/_app/redemption-history'
      path: '/redemption-history'
      fullPath: '/redemption-history'
      preLoaderRoute: typeof AppRedemptionHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/store': {
      id: '/_app/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof AppStoreRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-locked': {
      id: '/_app/account-locked'
      path: '/account-locked'
      fullPath: '/account-locked'
      preLoaderRoute: typeof AppAccountLockedImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/verification-required': {
      id: '/_app/verification-required'
      path: '/verification-required'
      fullPath: '/verification-required'
      preLoaderRoute: typeof AppVerificationRequiredImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/category/$id': {
      id: '/_app/category/$id'
      path: '/category/$id'
      fullPath: '/category/$id'
      preLoaderRoute: typeof AppCategoryIdRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/game-play/$gameId': {
      id: '/_app/game-play/$gameId'
      path: '/game-play/$gameId'
      fullPath: '/game-play/$gameId'
      preLoaderRoute: typeof AppGamePlayGameIdRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/access-controls': {
      id: '/_app/your-play/access-controls'
      path: '/your-play/access-controls'
      fullPath: '/your-play/access-controls'
      preLoaderRoute: typeof AppYourPlayAccessControlsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/gameplay-history': {
      id: '/_app/your-play/gameplay-history'
      path: '/your-play/gameplay-history'
      fullPath: '/your-play/gameplay-history'
      preLoaderRoute: typeof AppYourPlayGameplayHistoryRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/your-play/gameplay-limits': {
      id: '/_app/your-play/gameplay-limits'
      path: '/your-play/gameplay-limits'
      fullPath: '/your-play/gameplay-limits'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-verification_/flow': {
      id: '/_app/account-verification_/flow'
      path: '/account-verification/flow'
      fullPath: '/account-verification/flow'
      preLoaderRoute: typeof AppAccountVerificationFlowImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/account-verification_/tnc': {
      id: '/_app/account-verification_/tnc'
      path: '/account-verification/tnc'
      fullPath: '/account-verification/tnc'
      preLoaderRoute: typeof AppAccountVerificationTncImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/quests/active-quests': {
      id: '/_app/quests/active-quests'
      path: '/active-quests'
      fullPath: '/quests/active-quests'
      preLoaderRoute: typeof AppQuestsActiveQuestsImport
      parentRoute: typeof AppQuestsRouteImport
    }
    '/_app/quests/quests-history': {
      id: '/_app/quests/quests-history'
      path: '/quests-history'
      fullPath: '/quests/quests-history'
      preLoaderRoute: typeof AppQuestsQuestsHistoryImport
      parentRoute: typeof AppQuestsRouteImport
    }
    '/_app/store/buy-gold-coins': {
      id: '/_app/store/buy-gold-coins'
      path: '/buy-gold-coins'
      fullPath: '/store/buy-gold-coins'
      preLoaderRoute: typeof AppStoreBuyGoldCoinsImport
      parentRoute: typeof AppStoreRouteImport
    }
    '/_app/store/play-for-free': {
      id: '/_app/store/play-for-free'
      path: '/play-for-free'
      fullPath: '/store/play-for-free'
      preLoaderRoute: typeof AppStorePlayForFreeImport
      parentRoute: typeof AppStoreRouteImport
    }
    '/_app/your-play/access-controls/all': {
      id: '/_app/your-play/access-controls/all'
      path: '/all'
      fullPath: '/your-play/access-controls/all'
      preLoaderRoute: typeof AppYourPlayAccessControlsAllRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/self-exclusion': {
      id: '/_app/your-play/access-controls/self-exclusion'
      path: '/self-exclusion'
      fullPath: '/your-play/access-controls/self-exclusion'
      preLoaderRoute: typeof AppYourPlayAccessControlsSelfExclusionRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/self-exclusion-confirmation': {
      id: '/_app/your-play/access-controls/self-exclusion-confirmation'
      path: '/self-exclusion-confirmation'
      fullPath: '/your-play/access-controls/self-exclusion-confirmation'
      preLoaderRoute: typeof AppYourPlayAccessControlsSelfExclusionConfirmationRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/take-a-break': {
      id: '/_app/your-play/access-controls/take-a-break'
      path: '/take-a-break'
      fullPath: '/your-play/access-controls/take-a-break'
      preLoaderRoute: typeof AppYourPlayAccessControlsTakeABreakRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/access-controls/take-a-break-confirmation': {
      id: '/_app/your-play/access-controls/take-a-break-confirmation'
      path: '/take-a-break-confirmation'
      fullPath: '/your-play/access-controls/take-a-break-confirmation'
      preLoaderRoute: typeof AppYourPlayAccessControlsTakeABreakConfirmationRouteImport
      parentRoute: typeof AppYourPlayAccessControlsRouteImport
    }
    '/_app/your-play/gameplay-limits/add': {
      id: '/_app/your-play/gameplay-limits/add'
      path: '/add'
      fullPath: '/your-play/gameplay-limits/add'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsAddRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
    '/_app/your-play/gameplay-limits/all': {
      id: '/_app/your-play/gameplay-limits/all'
      path: '/all'
      fullPath: '/your-play/gameplay-limits/all'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsAllRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
    '/_app/your-play/gameplay-limits/manage/$type': {
      id: '/_app/your-play/gameplay-limits/manage/$type'
      path: '/manage/$type'
      fullPath: '/your-play/gameplay-limits/manage/$type'
      preLoaderRoute: typeof AppYourPlayGameplayLimitsManageTypeRouteImport
      parentRoute: typeof AppYourPlayGameplayLimitsRouteImport
    }
  }
}

// Create and export the route tree

interface AppQuestsRouteRouteChildren {
  AppQuestsActiveQuestsRoute: typeof AppQuestsActiveQuestsRoute
  AppQuestsQuestsHistoryRoute: typeof AppQuestsQuestsHistoryRoute
}

const AppQuestsRouteRouteChildren: AppQuestsRouteRouteChildren = {
  AppQuestsActiveQuestsRoute: AppQuestsActiveQuestsRoute,
  AppQuestsQuestsHistoryRoute: AppQuestsQuestsHistoryRoute,
}

const AppQuestsRouteRouteWithChildren = AppQuestsRouteRoute._addFileChildren(
  AppQuestsRouteRouteChildren,
)

interface AppStoreRouteRouteChildren {
  AppStoreBuyGoldCoinsRoute: typeof AppStoreBuyGoldCoinsRoute
  AppStorePlayForFreeRoute: typeof AppStorePlayForFreeRoute
}

const AppStoreRouteRouteChildren: AppStoreRouteRouteChildren = {
  AppStoreBuyGoldCoinsRoute: AppStoreBuyGoldCoinsRoute,
  AppStorePlayForFreeRoute: AppStorePlayForFreeRoute,
}

const AppStoreRouteRouteWithChildren = AppStoreRouteRoute._addFileChildren(
  AppStoreRouteRouteChildren,
)

interface AppYourPlayAccessControlsRouteRouteChildren {
  AppYourPlayAccessControlsAllRouteRoute: typeof AppYourPlayAccessControlsAllRouteRoute
  AppYourPlayAccessControlsSelfExclusionRouteRoute: typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute: typeof AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute
  AppYourPlayAccessControlsTakeABreakRouteRoute: typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute: typeof AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute
}

const AppYourPlayAccessControlsRouteRouteChildren: AppYourPlayAccessControlsRouteRouteChildren =
  {
    AppYourPlayAccessControlsAllRouteRoute:
      AppYourPlayAccessControlsAllRouteRoute,
    AppYourPlayAccessControlsSelfExclusionRouteRoute:
      AppYourPlayAccessControlsSelfExclusionRouteRoute,
    AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute:
      AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute,
    AppYourPlayAccessControlsTakeABreakRouteRoute:
      AppYourPlayAccessControlsTakeABreakRouteRoute,
    AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute:
      AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute,
  }

const AppYourPlayAccessControlsRouteRouteWithChildren =
  AppYourPlayAccessControlsRouteRoute._addFileChildren(
    AppYourPlayAccessControlsRouteRouteChildren,
  )

interface AppYourPlayGameplayLimitsRouteRouteChildren {
  AppYourPlayGameplayLimitsAddRouteRoute: typeof AppYourPlayGameplayLimitsAddRouteRoute
  AppYourPlayGameplayLimitsAllRouteRoute: typeof AppYourPlayGameplayLimitsAllRouteRoute
  AppYourPlayGameplayLimitsManageTypeRouteRoute: typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

const AppYourPlayGameplayLimitsRouteRouteChildren: AppYourPlayGameplayLimitsRouteRouteChildren =
  {
    AppYourPlayGameplayLimitsAddRouteRoute:
      AppYourPlayGameplayLimitsAddRouteRoute,
    AppYourPlayGameplayLimitsAllRouteRoute:
      AppYourPlayGameplayLimitsAllRouteRoute,
    AppYourPlayGameplayLimitsManageTypeRouteRoute:
      AppYourPlayGameplayLimitsManageTypeRouteRoute,
  }

const AppYourPlayGameplayLimitsRouteRouteWithChildren =
  AppYourPlayGameplayLimitsRouteRoute._addFileChildren(
    AppYourPlayGameplayLimitsRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppIndexRouteRoute: typeof AppIndexRouteRoute
  AppAccountVerificationRouteRoute: typeof AppAccountVerificationRouteRoute
  AppActivityLogRouteRoute: typeof AppActivityLogRouteRoute
  AppPurchaseHistoryRouteRoute: typeof AppPurchaseHistoryRouteRoute
  AppQuestsRouteRoute: typeof AppQuestsRouteRouteWithChildren
  AppRedeemRouteRoute: typeof AppRedeemRouteRoute
  AppRedemptionHistoryRouteRoute: typeof AppRedemptionHistoryRouteRoute
  AppSearchRouteRoute: typeof AppSearchRouteRoute
  AppStoreRouteRoute: typeof AppStoreRouteRouteWithChildren
  AppAccountLockedRoute: typeof AppAccountLockedRoute
  AppVerificationRequiredRoute: typeof AppVerificationRequiredRoute
  AppCategoryIdRouteRoute: typeof AppCategoryIdRouteRoute
  AppGamePlayGameIdRouteRoute: typeof AppGamePlayGameIdRouteRoute
  AppYourPlayAccessControlsRouteRoute: typeof AppYourPlayAccessControlsRouteRouteWithChildren
  AppYourPlayGameplayHistoryRouteRoute: typeof AppYourPlayGameplayHistoryRouteRoute
  AppYourPlayGameplayLimitsRouteRoute: typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  AppAccountVerificationFlowRoute: typeof AppAccountVerificationFlowRoute
  AppAccountVerificationTncRoute: typeof AppAccountVerificationTncRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRouteRoute: AppIndexRouteRoute,
  AppAccountVerificationRouteRoute: AppAccountVerificationRouteRoute,
  AppActivityLogRouteRoute: AppActivityLogRouteRoute,
  AppPurchaseHistoryRouteRoute: AppPurchaseHistoryRouteRoute,
  AppQuestsRouteRoute: AppQuestsRouteRouteWithChildren,
  AppRedeemRouteRoute: AppRedeemRouteRoute,
  AppRedemptionHistoryRouteRoute: AppRedemptionHistoryRouteRoute,
  AppSearchRouteRoute: AppSearchRouteRoute,
  AppStoreRouteRoute: AppStoreRouteRouteWithChildren,
  AppAccountLockedRoute: AppAccountLockedRoute,
  AppVerificationRequiredRoute: AppVerificationRequiredRoute,
  AppCategoryIdRouteRoute: AppCategoryIdRouteRoute,
  AppGamePlayGameIdRouteRoute: AppGamePlayGameIdRouteRoute,
  AppYourPlayAccessControlsRouteRoute:
    AppYourPlayAccessControlsRouteRouteWithChildren,
  AppYourPlayGameplayHistoryRouteRoute: AppYourPlayGameplayHistoryRouteRoute,
  AppYourPlayGameplayLimitsRouteRoute:
    AppYourPlayGameplayLimitsRouteRouteWithChildren,
  AppAccountVerificationFlowRoute: AppAccountVerificationFlowRoute,
  AppAccountVerificationTncRoute: AppAccountVerificationTncRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AppRouteRouteWithChildren
  '/age-restricted': typeof AgeRestrictedRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/': typeof AppIndexRouteRoute
  '/account-verification': typeof AppAccountVerificationRouteRoute
  '/activity-log': typeof AppActivityLogRouteRoute
  '/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/quests': typeof AppQuestsRouteRouteWithChildren
  '/redeem': typeof AppRedeemRouteRoute
  '/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/search': typeof AppSearchRouteRoute
  '/store': typeof AppStoreRouteRouteWithChildren
  '/account-locked': typeof AppAccountLockedRoute
  '/verification-required': typeof AppVerificationRequiredRoute
  '/category/$id': typeof AppCategoryIdRouteRoute
  '/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/account-verification/flow': typeof AppAccountVerificationFlowRoute
  '/account-verification/tnc': typeof AppAccountVerificationTncRoute
  '/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRoute
  '/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/your-play/access-controls/self-exclusion-confirmation': typeof AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute
  '/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/your-play/access-controls/take-a-break-confirmation': typeof AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute
  '/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRoutesByTo {
  '/age-restricted': typeof AgeRestrictedRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/': typeof AppIndexRouteRoute
  '/account-verification': typeof AppAccountVerificationRouteRoute
  '/activity-log': typeof AppActivityLogRouteRoute
  '/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/quests': typeof AppQuestsRouteRouteWithChildren
  '/redeem': typeof AppRedeemRouteRoute
  '/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/search': typeof AppSearchRouteRoute
  '/store': typeof AppStoreRouteRouteWithChildren
  '/account-locked': typeof AppAccountLockedRoute
  '/verification-required': typeof AppVerificationRequiredRoute
  '/category/$id': typeof AppCategoryIdRouteRoute
  '/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/account-verification/flow': typeof AppAccountVerificationFlowRoute
  '/account-verification/tnc': typeof AppAccountVerificationTncRoute
  '/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRoute
  '/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/your-play/access-controls/self-exclusion-confirmation': typeof AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute
  '/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/your-play/access-controls/take-a-break-confirmation': typeof AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute
  '/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/age-restricted': typeof AgeRestrictedRoute
  '/geo-block': typeof GeoBlockRoute
  '/inactivity-logout': typeof InactivityLogoutRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/postal-request-code': typeof PostalRequestCodeRoute
  '/register': typeof RegisterRoute
  '/_app/': typeof AppIndexRouteRoute
  '/_app/account-verification': typeof AppAccountVerificationRouteRoute
  '/_app/activity-log': typeof AppActivityLogRouteRoute
  '/_app/purchase-history': typeof AppPurchaseHistoryRouteRoute
  '/_app/quests': typeof AppQuestsRouteRouteWithChildren
  '/_app/redeem': typeof AppRedeemRouteRoute
  '/_app/redemption-history': typeof AppRedemptionHistoryRouteRoute
  '/_app/search': typeof AppSearchRouteRoute
  '/_app/store': typeof AppStoreRouteRouteWithChildren
  '/_app/account-locked': typeof AppAccountLockedRoute
  '/_app/verification-required': typeof AppVerificationRequiredRoute
  '/_app/category/$id': typeof AppCategoryIdRouteRoute
  '/_app/game-play/$gameId': typeof AppGamePlayGameIdRouteRoute
  '/_app/your-play/access-controls': typeof AppYourPlayAccessControlsRouteRouteWithChildren
  '/_app/your-play/gameplay-history': typeof AppYourPlayGameplayHistoryRouteRoute
  '/_app/your-play/gameplay-limits': typeof AppYourPlayGameplayLimitsRouteRouteWithChildren
  '/_app/account-verification_/flow': typeof AppAccountVerificationFlowRoute
  '/_app/account-verification_/tnc': typeof AppAccountVerificationTncRoute
  '/_app/quests/active-quests': typeof AppQuestsActiveQuestsRoute
  '/_app/quests/quests-history': typeof AppQuestsQuestsHistoryRoute
  '/_app/store/buy-gold-coins': typeof AppStoreBuyGoldCoinsRoute
  '/_app/store/play-for-free': typeof AppStorePlayForFreeRoute
  '/_app/your-play/access-controls/all': typeof AppYourPlayAccessControlsAllRouteRoute
  '/_app/your-play/access-controls/self-exclusion': typeof AppYourPlayAccessControlsSelfExclusionRouteRoute
  '/_app/your-play/access-controls/self-exclusion-confirmation': typeof AppYourPlayAccessControlsSelfExclusionConfirmationRouteRoute
  '/_app/your-play/access-controls/take-a-break': typeof AppYourPlayAccessControlsTakeABreakRouteRoute
  '/_app/your-play/access-controls/take-a-break-confirmation': typeof AppYourPlayAccessControlsTakeABreakConfirmationRouteRoute
  '/_app/your-play/gameplay-limits/add': typeof AppYourPlayGameplayLimitsAddRouteRoute
  '/_app/your-play/gameplay-limits/all': typeof AppYourPlayGameplayLimitsAllRouteRoute
  '/_app/your-play/gameplay-limits/manage/$type': typeof AppYourPlayGameplayLimitsManageTypeRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/age-restricted'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/'
    | '/account-verification'
    | '/activity-log'
    | '/purchase-history'
    | '/quests'
    | '/redeem'
    | '/redemption-history'
    | '/search'
    | '/store'
    | '/account-locked'
    | '/verification-required'
    | '/category/$id'
    | '/game-play/$gameId'
    | '/your-play/access-controls'
    | '/your-play/gameplay-history'
    | '/your-play/gameplay-limits'
    | '/account-verification/flow'
    | '/account-verification/tnc'
    | '/quests/active-quests'
    | '/quests/quests-history'
    | '/store/buy-gold-coins'
    | '/store/play-for-free'
    | '/your-play/access-controls/all'
    | '/your-play/access-controls/self-exclusion'
    | '/your-play/access-controls/self-exclusion-confirmation'
    | '/your-play/access-controls/take-a-break'
    | '/your-play/access-controls/take-a-break-confirmation'
    | '/your-play/gameplay-limits/add'
    | '/your-play/gameplay-limits/all'
    | '/your-play/gameplay-limits/manage/$type'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/age-restricted'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/'
    | '/account-verification'
    | '/activity-log'
    | '/purchase-history'
    | '/quests'
    | '/redeem'
    | '/redemption-history'
    | '/search'
    | '/store'
    | '/account-locked'
    | '/verification-required'
    | '/category/$id'
    | '/game-play/$gameId'
    | '/your-play/access-controls'
    | '/your-play/gameplay-history'
    | '/your-play/gameplay-limits'
    | '/account-verification/flow'
    | '/account-verification/tnc'
    | '/quests/active-quests'
    | '/quests/quests-history'
    | '/store/buy-gold-coins'
    | '/store/play-for-free'
    | '/your-play/access-controls/all'
    | '/your-play/access-controls/self-exclusion'
    | '/your-play/access-controls/self-exclusion-confirmation'
    | '/your-play/access-controls/take-a-break'
    | '/your-play/access-controls/take-a-break-confirmation'
    | '/your-play/gameplay-limits/add'
    | '/your-play/gameplay-limits/all'
    | '/your-play/gameplay-limits/manage/$type'
  id:
    | '__root__'
    | '/_app'
    | '/age-restricted'
    | '/geo-block'
    | '/inactivity-logout'
    | '/login'
    | '/logout'
    | '/postal-request-code'
    | '/register'
    | '/_app/'
    | '/_app/account-verification'
    | '/_app/activity-log'
    | '/_app/purchase-history'
    | '/_app/quests'
    | '/_app/redeem'
    | '/_app/redemption-history'
    | '/_app/search'
    | '/_app/store'
    | '/_app/account-locked'
    | '/_app/verification-required'
    | '/_app/category/$id'
    | '/_app/game-play/$gameId'
    | '/_app/your-play/access-controls'
    | '/_app/your-play/gameplay-history'
    | '/_app/your-play/gameplay-limits'
    | '/_app/account-verification_/flow'
    | '/_app/account-verification_/tnc'
    | '/_app/quests/active-quests'
    | '/_app/quests/quests-history'
    | '/_app/store/buy-gold-coins'
    | '/_app/store/play-for-free'
    | '/_app/your-play/access-controls/all'
    | '/_app/your-play/access-controls/self-exclusion'
    | '/_app/your-play/access-controls/self-exclusion-confirmation'
    | '/_app/your-play/access-controls/take-a-break'
    | '/_app/your-play/access-controls/take-a-break-confirmation'
    | '/_app/your-play/gameplay-limits/add'
    | '/_app/your-play/gameplay-limits/all'
    | '/_app/your-play/gameplay-limits/manage/$type'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AgeRestrictedRoute: typeof AgeRestrictedRoute
  GeoBlockRoute: typeof GeoBlockRoute
  InactivityLogoutRoute: typeof InactivityLogoutRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PostalRequestCodeRoute: typeof PostalRequestCodeRoute
  RegisterRoute: typeof RegisterRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AgeRestrictedRoute: AgeRestrictedRoute,
  GeoBlockRoute: GeoBlockRoute,
  InactivityLogoutRoute: InactivityLogoutRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PostalRequestCodeRoute: PostalRequestCodeRoute,
  RegisterRoute: RegisterRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/age-restricted",
        "/geo-block",
        "/inactivity-logout",
        "/login",
        "/logout",
        "/postal-request-code",
        "/register"
      ]
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/",
        "/_app/account-verification",
        "/_app/activity-log",
        "/_app/purchase-history",
        "/_app/quests",
        "/_app/redeem",
        "/_app/redemption-history",
        "/_app/search",
        "/_app/store",
        "/_app/account-locked",
        "/_app/verification-required",
        "/_app/category/$id",
        "/_app/game-play/$gameId",
        "/_app/your-play/access-controls",
        "/_app/your-play/gameplay-history",
        "/_app/your-play/gameplay-limits",
        "/_app/account-verification_/flow",
        "/_app/account-verification_/tnc"
      ]
    },
    "/age-restricted": {
      "filePath": "age-restricted.tsx"
    },
    "/geo-block": {
      "filePath": "geo-block.tsx"
    },
    "/inactivity-logout": {
      "filePath": "inactivity-logout.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/postal-request-code": {
      "filePath": "postal-request-code.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/_app/": {
      "filePath": "_app/index/route.tsx",
      "parent": "/_app"
    },
    "/_app/account-verification": {
      "filePath": "_app/account-verification/route.tsx",
      "parent": "/_app"
    },
    "/_app/activity-log": {
      "filePath": "_app/activity-log/route.tsx",
      "parent": "/_app"
    },
    "/_app/purchase-history": {
      "filePath": "_app/purchase-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/quests": {
      "filePath": "_app/quests/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/quests/active-quests",
        "/_app/quests/quests-history"
      ]
    },
    "/_app/redeem": {
      "filePath": "_app/redeem/route.tsx",
      "parent": "/_app"
    },
    "/_app/redemption-history": {
      "filePath": "_app/redemption-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/search": {
      "filePath": "_app/search/route.tsx",
      "parent": "/_app"
    },
    "/_app/store": {
      "filePath": "_app/store/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/store/buy-gold-coins",
        "/_app/store/play-for-free"
      ]
    },
    "/_app/account-locked": {
      "filePath": "_app/account-locked.tsx",
      "parent": "/_app"
    },
    "/_app/verification-required": {
      "filePath": "_app/verification-required.tsx",
      "parent": "/_app"
    },
    "/_app/category/$id": {
      "filePath": "_app/category.$id/route.tsx",
      "parent": "/_app"
    },
    "/_app/game-play/$gameId": {
      "filePath": "_app/game-play.$gameId/route.tsx",
      "parent": "/_app"
    },
    "/_app/your-play/access-controls": {
      "filePath": "_app/your-play.access-controls/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/your-play/access-controls/all",
        "/_app/your-play/access-controls/self-exclusion",
        "/_app/your-play/access-controls/self-exclusion-confirmation",
        "/_app/your-play/access-controls/take-a-break",
        "/_app/your-play/access-controls/take-a-break-confirmation"
      ]
    },
    "/_app/your-play/gameplay-history": {
      "filePath": "_app/your-play.gameplay-history/route.tsx",
      "parent": "/_app"
    },
    "/_app/your-play/gameplay-limits": {
      "filePath": "_app/your-play.gameplay-limits/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/your-play/gameplay-limits/add",
        "/_app/your-play/gameplay-limits/all",
        "/_app/your-play/gameplay-limits/manage/$type"
      ]
    },
    "/_app/account-verification_/flow": {
      "filePath": "_app/account-verification_/flow.tsx",
      "parent": "/_app"
    },
    "/_app/account-verification_/tnc": {
      "filePath": "_app/account-verification_/tnc.tsx",
      "parent": "/_app"
    },
    "/_app/quests/active-quests": {
      "filePath": "_app/quests/active-quests.tsx",
      "parent": "/_app/quests"
    },
    "/_app/quests/quests-history": {
      "filePath": "_app/quests/quests-history.tsx",
      "parent": "/_app/quests"
    },
    "/_app/store/buy-gold-coins": {
      "filePath": "_app/store/buy-gold-coins.tsx",
      "parent": "/_app/store"
    },
    "/_app/store/play-for-free": {
      "filePath": "_app/store/play-for-free.tsx",
      "parent": "/_app/store"
    },
    "/_app/your-play/access-controls/all": {
      "filePath": "_app/your-play.access-controls/all/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/self-exclusion": {
      "filePath": "_app/your-play.access-controls/self-exclusion/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/self-exclusion-confirmation": {
      "filePath": "_app/your-play.access-controls/self-exclusion-confirmation/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/take-a-break": {
      "filePath": "_app/your-play.access-controls/take-a-break/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/access-controls/take-a-break-confirmation": {
      "filePath": "_app/your-play.access-controls/take-a-break-confirmation/route.tsx",
      "parent": "/_app/your-play/access-controls"
    },
    "/_app/your-play/gameplay-limits/add": {
      "filePath": "_app/your-play.gameplay-limits/add/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    },
    "/_app/your-play/gameplay-limits/all": {
      "filePath": "_app/your-play.gameplay-limits/all/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    },
    "/_app/your-play/gameplay-limits/manage/$type": {
      "filePath": "_app/your-play.gameplay-limits/manage.$type/route.tsx",
      "parent": "/_app/your-play/gameplay-limits"
    }
  }
}
ROUTE_MANIFEST_END */
